import { render, staticRenderFns } from "./customer-sample-requests.vue?vue&type=template&id=86c8ad2a&"
import script from "./customer-sample-requests.vue?vue&type=script&lang=js&"
export * from "./customer-sample-requests.vue?vue&type=script&lang=js&"
import style0 from "./customer-sample-requests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports